import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { capitalize } from '@modernhealth/capitalize';
import * as styles from './CalloutInline.module.scss';
import * as typographyStyles from '../Typography/Typography.module.scss';
import { Icon } from '../Icon/Icon';
import { HeadingText20 } from '../Typography/Typography';
import { IconButton } from '../..';
export var CalloutAtom;
(function (CalloutAtom) {
    CalloutAtom["Background"] = "background";
    CalloutAtom["Text"] = "text";
    CalloutAtom["Icon"] = "icon";
    CalloutAtom["Dismiss"] = "dismiss";
})(CalloutAtom || (CalloutAtom = {}));
export const mapCalloutVariantToIcon = {
    info: 'info-enclosed-filled',
    success: 'checkmark-enclosed-filled',
    warning: 'warning-enclosed-filled',
    danger: 'alert-enclosed-filled',
    default: 'info-enclosed-filled',
};
export const CalloutInline = ({ variant, heading, showIcon = true, onDismiss, className, children, }) => {
    const containerStyle = clsx([
        styles.container,
        styles[`container${capitalize(variant)}`],
    ]);
    const childrenStyle = clsx([
        typographyStyles.body,
        typographyStyles.bodySm,
        styles.text,
    ]);
    return (_jsxs("div", { className: clsx(containerStyle, className), children: [showIcon && (_jsx(Icon, { name: mapCalloutVariantToIcon[variant], className: styles.icon, size: 20 })), _jsxs("div", { className: styles.content, children: [!!heading && (_jsx(HeadingText20, { className: styles.heading, as: "span", children: heading })), !!children && _jsx("div", { className: childrenStyle, children: children })] }), onDismiss && (_jsx(IconButton, { title: "Dismiss", className: styles.dismissButton, onClick: onDismiss, icon: "x", size: "medium", variant: "transparent" }))] }));
};
